import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "redux/actions/auth";
// Axios
import axios from "axios";

const useHttp = (initialLoadingState= true) => {
    // initialize states
    const [isLoading, setIsLoading] = useState(initialLoadingState);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // axios configs
    axios.defaults.withCredentials = true;

    const sendRequest = useCallback(async (requestConfig, applyData) => {
        // let API = axios.create({ baseURL: `${process.env.REACT_APP_PRODUCTION_API_URL}/api/v1` });
        let API;
        if (process.env.NODE_ENV === "production") {
            API = axios.create({ baseURL: `${process.env.REACT_APP_PRODUCTION_API_URL}/api/v1` });
        } else {
            //API = axios.create({ baseURL: `${process.env.REACT_APP_DEVELOPMENT_API_URL}/api/v1` });
            API = axios.create({ baseURL: `${process.env.REACT_APP_DEVELOPMENT_API_URL}/api/v1/` });
        }

        setIsLoading(true);
        setError(null);

        try {
            const defaultHeaders = requestConfig.data instanceof FormData
                ? {}
                : { 'content-type': 'application/json' };
            const { data } = await API({
                url: requestConfig.url,
                method: requestConfig.method ? requestConfig.method : "GET",
                headers: requestConfig.headers ? requestConfig.headers : defaultHeaders,
                data: requestConfig.data ? requestConfig.data : null
            });
            if (applyData) {
                applyData(data);
            }
        } catch (error) {
            if(error == 'Error: Request failed with status code 401'){
                dispatch(logout())
            }else{
                console.log(error);
                setError(error.message || "خطا، لطفا دوباره امتحان کنید.");
            }
            throw error;
        } finally {
            setTimeout(() => { setIsLoading(false); }, 500);
        }

    }, [dispatch]);

    return { isLoading, error, sendRequest };
};

export default useHttp;
